import { Injectable } from "@angular/core";
import { HttpHeaders,HttpClient } from "@angular/common/http";

@Injectable()

export class ShipmentService{
    constructor(private http:HttpClient)
    {
      console.log('instance created');
    }

    httpOptions ={
        headers: new HttpHeaders({'Content-Type':'application/json'})
    };

    getShipments(){
        return this.http.get('/shipments');
    }

    getDriverShipments(driverId:string, include:any){
        let config = {
            headers: new HttpHeaders({'Content-Type':'application/json'})
        };
        config["params"] = {
            filter: JSON.stringify({include:include, where:{"driverId":driverId}})
        };
        return this.http.get('/shipments', config);
    }

    getAnalytics(data){
        let config = {
          headers: new HttpHeaders({'Content-Type':'application/json'})
      };
      config["params"] = {
          filter: JSON.stringify({where:{"startDate	":data.startDate,"endDate":data.endDate}})
      };
      return this.http.get('/shipments/getShipmentAnalytics', config);
      }

    // getShipmentWithConsignment(consignmentId:string){
    //     let config = {
    //         headers: new HttpHeaders({'Content-Type':'application/json'})
    //     };
    //     config["params"] = {
    //         filter: JSON.stringify({include:include, where:{"driverId":driverId}})
    //     };
    //     return this.http.get('/shipments', config);
    // }


    getShipmentById(shipmentId:string)
    {
        return this.http.get('/shipments/'+shipmentId,this.httpOptions);
    }

    getShipmentVehicleDevice(id:string)
    {
        return this.http.get('/shipments/'+id+'/getShipmentLocation',this.httpOptions);
    }
    
    getTripRouteById(routeId:string)
    {
        return this.http.get('/routes/'+routeId,this.httpOptions);
    }
    getShipmentByDate(year:string, month:string)
    {
        let body ='tripyear='+year+'&tripmonth='+month;
        return this.http.get('/shipments?'+body);
    }
    deleteShipment(data) {
        return this.http.delete('/shipments/' + data.id);
    }
    createShipment(data) {
        let body = JSON.stringify(data);
        return this.http.post('/shipments/', body, this.httpOptions);
    }
    updateShipment(data) {
        let body = JSON.stringify(data);
        return this.http.put('/shipments/' + data.id, body, this.httpOptions);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/shipments/shipment.service.ts